// @ts-check

// Keep these aligned with Create Campaign (CampaignBasicData DataForm).
const CAMPAIGN_NAME_MIN_LENGTH = 5;
const CAMPAIGN_NAME_MAX_LENGTH = 60;

/* eslint-disable max-len */
const ERROR_CAMPAIGN_NAME_MAX_LENGTH = `Please use a max of ${CAMPAIGN_NAME_MAX_LENGTH} characters in your Campaign Name.`;
const ERROR_CAMPAIGN_NAME_MIN_LENGTH = `Please use a minimum of ${CAMPAIGN_NAME_MIN_LENGTH} characters in your Campaign Name.`;
/* eslint-enable max-len */

export {
  CAMPAIGN_NAME_MIN_LENGTH,
  CAMPAIGN_NAME_MAX_LENGTH,
  ERROR_CAMPAIGN_NAME_MAX_LENGTH,
  ERROR_CAMPAIGN_NAME_MIN_LENGTH,
};
